const getters = {
    customers: (state) => state.customers,
    dateRange: (state) => state.dateRange,
    activeTab: (state) => state.activeTab,
    analysisMode: (state) => state.analysisMode,
    analysisResults: (state) => state.analysisResults,
    loadingMap: (state) => state.loadingMap,
    progressMap: (state) => state.progressMap,
    analysisParameters: (state) => state.analysisParameters,
    backendMessages: (state) => state.backendMessages,
    isAnalysisLoading: (state) => (analysisType) => state.loadingMap[analysisType],
    getAnalysisResult: (state) => (analysisType) => state.analysisResults[analysisType],
    getAnalysisParameters: (state) => (analysisType) => state.analysisParameters[analysisType],
    hasCustomers: (state) => state.customers.length > 0,
    hasDateRange: (state) => state.dateRange.startDate !== null && state.dateRange.endDate !== null,
    canRunAnalysis: (state) => {
        const hasDateRange = state.dateRange.startDate !== null && state.dateRange.endDate !== null;
        if (!hasDateRange) return false;
        return state.customers.length >= 1;
    },
    isAnyLoading: (state) => {
        return Object.values(state.loadingMap).some((v) => v === true);
    },
    multiHopResults: (state) => state.multiHopResults,
    multiHopLoading: (state) => state.multiHopLoading,
    connectionPaths: (state) => state.connectionPaths,
    connectionLoading: (state) => state.connectionLoading,
    analysisSummaries: (state) => {
        const summaries = {};
        Object.keys(state.analysisResults).forEach((key) => {
            const r = state.analysisResults[key];
            summaries[key] = r ? { itemCount: r.items ? r.items.length : 0, totalRowCount: r.totalRowCount || 0 } : null;
        });
        return summaries;
    },
    overallRiskScore: (state) => {
        const cp = state.analysisResults.customerProfile;
        if (!cp || !cp.items || !cp.items.length) return null;
        const score = cp.items[0].overallRiskScore;
        return score !== undefined ? score : null;
    },
    crossReferencedTransactions: (state) => {
        const txMap = {};
        const TAB_TX_EXTRACTORS = {
            anomalyDetection: (items) => items.map((i) => i.transactionId).filter(Boolean),
            structuringDetection: (items) => {
                const ids = [];
                items.forEach((i) => {
                    const parsed = i.transactionIdsJson;
                    if (Array.isArray(parsed)) ids.push(...parsed);
                });
                return ids;
            },
            cashTransactions: (items) => {
                const ids = [];
                items.forEach((i) => {
                    const txs = i.cashTransactionsJson;
                    if (Array.isArray(txs)) txs.forEach((t) => { if (t.transactionId) ids.push(t.transactionId); });
                });
                return ids;
            },
            layeringDetection: (items) => {
                const ids = [];
                items.forEach((i) => {
                    const txs = i.transactionIdsJson;
                    if (Array.isArray(txs)) ids.push(...txs);
                });
                return ids;
            }
        };

        Object.entries(TAB_TX_EXTRACTORS).forEach(([tabKey, extractor]) => {
            const result = state.analysisResults[tabKey];
            if (!result || !result.items) return;
            const txIds = extractor(result.items);
            txIds.forEach((id) => {
                if (!txMap[id]) txMap[id] = new Set();
                txMap[id].add(tabKey);
            });
        });

        const crossRef = {};
        Object.entries(txMap).forEach(([id, tabs]) => {
            if (tabs.size >= 2) crossRef[id] = Array.from(tabs);
        });
        return crossRef;
    }
};

export default getters;
